<main>
    <div class="classe_left">
        <app-menus></app-menus>
    </div>
    <div class="classe_right">
        <h2>Classe: {{classeName}}</h2>
        <div class="classe_infos">
            <h3><b>Informations générales</b></h3>
            <hr>
            <label for="level">
                <p>Niveau de la classe:</p>
                <input type="text" name="level" [value]="classeLevels" disabled>
            </label>
            <label for="stars">
                <p>Etoiles gagnées:</p>
                <input type="text" name="stars" value="{{classeStars.toFixed(1)}}" disabled>
            </label>
            <label for="resp">
                <p>Responsable de classe:</p>
                <input type="text" name="resp" [value]="classResp" disabled>
            </label>
            <label for="cdc">
                <p>Code de classe:</p>
                <input type="text" name="cdc" [value]="classeId" disabled>
            </label>
            <h3 *ngIf="userType == 'enseignant'"><b>Liste d'élèves</b></h3>
            <hr>
            <div class="classe_liste" *ngIf="classeStudentList != [] && userType == 'enseignant'" >
                <p *ngFor="let student of classeStudentList" >{{student}}</p>
            </div>
            <p class="p_noStd" *ngIf="classeStudentList == [] && userType == 'enseignant'">Il n'y a aucun élève dans cette classe</p>
        </div>
    </div>
</main>
